module.exports = __webpack_public_path__ + "155526fcd8084c539f586b5fdadd5526.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/furnitures/wall_items/window-sunny-mountains.png
// module id = 1650
// module chunks = 0